<template>
    <evp-layout>
        <navigation-header
            :return-url="route('article')"
            :title="$t('article.PrinciplesTitle')"
        />

        <article class="body-col-6 bg-surface rounded-md">
            <img src="@/images/title-banner/principles.png" class="w-full h-[calc(100vw/4.7)] max-h-[300px]" />
            
            <div class="px-5 py-10 md:px-36 [&>p]:pb-8">
                <p>eVeselībasPunkts ir platforma, kurā publicē rakstus ar veselību saistītajos tematos, lai izglītotu lasītājus un kļūtu par uzticamu veselības informācijas avotu.</p>
                <p>Publicējot rakstus, mēs izvērtējam to saturu atbilstoši trīs principiem: patiesība, autoritāte, atbildība.</p>
                <h2 class="mt-10 mb-5 text-xl">Patiesība</h2>
                <p>Rakstos publicēta informācija ir patiesa, nav maldinoša un sakrīt ar mūsdienu zinātnisko konsensu medicīnas jautājumos.</p>
                <p>Jebkāda veida reklāmas vai cita veida apmaksātie raksti tiek atzīmēti ar ikonu 
                    <span style="display:inline-block"><svg class="h-5 pt-1 w-5 fill-yellow-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm4.24 16L12 15.45 7.77 18l1.12-4.81-3.73-3.23 4.92-.42L12 5l1.92 4.53 4.92.42-3.73 3.23L16.23 18z" /></svg></span>
                    un pazīmi “Raksts ir apmaksāts”, norādot maksātāju.</p>
                <p>Raksti, kas sniedz informāciju par t.s. komplimentāro un alternatīvo medicīnu vai citām nepārbaudītām, nestrādājošām vai maldinošām metodēm, ir ievietoti kategorijā <a class="link-primary" :href="route('article-category', { category: 'cam' })">„Alternatīvā medicīna”</a>.</p>
                <h2 class="mt-10 mb-5 text-xl">Autoritāte</h2>
                <p>Rakstu autori ir ārstniecības personas vai personas saistītas ar veselības aprūpi, ārstniecību, fitnesu vai citu jomu, kas saistīta ar raksta tematiku.</p>
                <h2 class="mt-10 mb-5 text-xl">Atbildība</h2>
                <p>Atbildība par rakstu saturu, tajā paustiem viedokļiem un stilu paliek raksta autoram – eVeselībasPunkts ir publikācijas platforma, nevis satura veidotājs.</p>
                <p>eVeselībasPunkts patur iespēju jebkurā brīdī lemt par jebkura raksta izņemšanu no publikācijas.</p>
                <p>Ja atrodi šo principu pārkāpumu vai vienkārši drukas kļūdu, būsim pateicīgi, ja ziņosi mums, rakstot <a class="link-primary" href="mailto:hd@medicloud.lv">e-pastu uz hd@medicloud.lv</a> vai <a
                    class="link-primary"
                    href="http://m.me/eVeselibasPunkts.lv"
                    rel="external noreferrer noopener"
                    target="_blank"
                >ziņu Messengerī</a>.</p>
            </div>
        </article>
    </evp-layout>
</template>

<script setup>
    import EvpLayout from '@/components/EvpLayout.vue'
    import { route } from 'ziggy'
    import NavigationHeader from '@/components/NavigationHeader.vue'
</script>